export const EXCMUSERDATASALESOPPORTUNITY_SHOW_RESET = 'EXCMUSERDATASALESOPPORTUNITY_SHOW_RESET'
export const EXCMUSERDATASALESOPPORTUNITY_SHOW_SET_ERROR = 'EXCMUSERDATASALESOPPORTUNITY_SHOW_SET_ERROR'
export const EXCMUSERDATASALESOPPORTUNITY_SHOW_SET_RETRIEVED = 'EXCMUSERDATASALESOPPORTUNITY_SHOW_SET_RETRIEVED'
export const EXCMUSERDATASALESOPPORTUNITY_SHOW_TOGGLE_LOADING = 'EXCMUSERDATASALESOPPORTUNITY_SHOW_TOGGLE_LOADING'
